import { timeParse } from 'd3'

const earningsAndValuationRiskChartData = [
    {
        "dateString": "2010-12-31",
        "earnings_yield_deviation": "",
        "earnings_yield_h_deviation": "0.018847099",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2011-06-30",
        "earnings_yield_deviation": "",
        "earnings_yield_h_deviation": "0.083498974",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2011-12-31",
        "earnings_yield_deviation": "",
        "earnings_yield_h_deviation": "0.005251542",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2012-06-30",
        "earnings_yield_deviation": "",
        "earnings_yield_h_deviation": "-0.003307044",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2012-12-31",
        "earnings_yield_deviation": "",
        "earnings_yield_h_deviation": "-0.312535591",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2013-06-30",
        "earnings_yield_deviation": "0.26791472",
        "earnings_yield_h_deviation": "-0.274352776",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2013-12-31",
        "earnings_yield_deviation": "-1.493858887",
        "earnings_yield_h_deviation": "-0.511733877",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2014-06-30",
        "earnings_yield_deviation": "0.097285875",
        "earnings_yield_h_deviation": "-0.317633364",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2014-12-31",
        "earnings_yield_deviation": "3.087450545",
        "earnings_yield_h_deviation": "-0.16877811",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2015-06-30",
        "earnings_yield_deviation": "2.705793467",
        "earnings_yield_h_deviation": "-0.121893887",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2015-12-31",
        "earnings_yield_deviation": "0.473020926",
        "earnings_yield_h_deviation": "-0.00455904",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2016-06-30",
        "earnings_yield_deviation": "-0.040113317",
        "earnings_yield_h_deviation": "0.060957179",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2016-12-31",
        "earnings_yield_deviation": "-1.174256302",
        "earnings_yield_h_deviation": "0.006486218",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2017-06-30",
        "earnings_yield_deviation": "-0.948081365",
        "earnings_yield_h_deviation": "0.122135546",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2017-12-31",
        "earnings_yield_deviation": "-0.707340789",
        "earnings_yield_h_deviation": "0.085683587",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2018-06-30",
        "earnings_yield_deviation": "-0.152620291",
        "earnings_yield_h_deviation": "0.126277776",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2018-12-31",
        "earnings_yield_deviation": "0.725311363",
        "earnings_yield_h_deviation": "0.134135791",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2019-06-30",
        "earnings_yield_deviation": "0.493468386",
        "earnings_yield_h_deviation": "0.154062678",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2019-12-31",
        "earnings_yield_deviation": "0.111044585",
        "earnings_yield_h_deviation": "0.243874485",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    },
    {
        "dateString": "2020-06-30",
        "earnings_yield_deviation": "-3.909558799",
        "earnings_yield_h_deviation": "0.520972033",
        "chart_name": "Earnings & Valuation Risk (Earnings Yield)",
        "chart_number": "9"
    }
]

const parseDate = timeParse('%Y-%m-%d')

export default earningsAndValuationRiskChartData.map(d => {
  d['date'] = parseDate(d['dateString'])
  return d
})
